import {Component, ViewEncapsulation} from '@angular/core';
import {LoaderService, NavigateService} from 'ngx-satoris';
import {CartService} from '../../../shared/services/cart.service';
import {DocumentType} from '../../../shared/models/user';
import {convertUpperCase} from '../../../shared/utils/string';
import {ApiService} from 'src/app/shared/services/api.service';
import {RequestService} from 'src/app/shared/services/request.service';

@Component({
  selector: 'app-document-management',
  templateUrl: './document-management.component.html',
  styleUrls: ['./document-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DocumentManagementComponent {

  constructor(private api: ApiService,
    public nav: NavigateService,
    public cart: CartService,
    private loader : LoaderService,
    private request: RequestService) {}

  convertUppercase = convertUpperCase;

  onClick(document: DocumentType) {
    this.cart.setStorageOLD({document_type: document, fromRoute: 'document'}, true);
    if(document === DocumentType.PREENROLL) {
      this.nav.to('people');
    }
    if(document === DocumentType.EMBASSYPASS) {
      this.nav.to('document-embassy');
    }
    if(this.request.isDocumentType(document)) {
      if(this.api.env.type === DocumentType.ZWEVISA) {
        if(this.cart.cartDatas?.form_config) {
          const actualConfig = this.cart.getOriginalFormOLD(document);
          if(!this.cart.areConfigEqual(this.cart.cartDatas.form_config, actualConfig)){
            this.loader.loading(true, {type: 'info', message: 'cart.load.otherConfig', btnLabel: 'yes', custom: {closeBtnLabel: 'global.close'}}).then((done: boolean) => {
              if(done) {
                this.cart.removeStorageOLD();
                this.cart.setStorageOLD({document_type: document, fromRoute: 'document'});
                this.nav.to('form-visa-intro');
              }
            });
          } else {
            this.loader.loading(true, {type: 'info', message: 'cart.load', btnLabel: 'yes', custom: {closeBtnLabel: 'no'}}).then((done: boolean) => {
              if(!done) {
                this.cart.removeStorageOLD();
                this.cart.setStorageOLD({document_type: document, fromRoute: 'document'});
              }
              this.nav.to('form-visa-intro');
            });
          }
        } else {
          this.nav.to('form-visa-intro');
        }
      }
    }
  }

  allDocuments() {
    if(this.api.userRole.isCustomer) {
      return this.api.userInfo.server.paymentRequests.filter(product => product.id === DocumentType.PREENROLL);
    } else if(this.api.userRole.isKiosk) {
      return this.api.userInfo.server.paymentRequests.filter(product => product.kiosk);
    } else {
      return this.api.userInfo.server.paymentRequests;
    }
  }

  protected readonly DocumentType = DocumentType;
}
